__turbopack_context__.v({
  "dropdown": "styles-module__ynAD7q__dropdown",
  "dropdownItem": "styles-module__ynAD7q__dropdownItem",
  "dropdownList": "styles-module__ynAD7q__dropdownList",
});
